import Vue from 'vue'
import VueRouter from 'vue-router'
import ContactPage from '@/views/ContactPage'
import NotFoundPage from '@/views/404'
import PrivacyPolicyGerman from "@/views/PrivacyPolicyGerman";
import Business from "@/views/home-pages/Business";
import VueMeta from "vue-meta";
import PrivacyPolicyEnglish from "@/views/PrivacyPolicyEnglish";
import ImprintGerman from "@/views/ImprintGerman";
import ImprintEnglish from "@/views/ImprintEnglish";

Vue.use(VueRouter)
Vue.use(VueMeta, {
  refreshOnceOnNavigation: false,
})

const routes = [
  {
    path: '',
    name: 'Home',
    component: Business,
  },
  {
    path: '/imprint',
    name: 'Imprint',
    component: process.env.VUE_APP_DOMAIN.includes('de') ? ImprintGerman : ImprintEnglish,
  },
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: process.env.VUE_APP_DOMAIN.includes('de') ? PrivacyPolicyGerman : PrivacyPolicyEnglish,
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage,
  },
  {
    path: '*',
    name: 'NotFoundPage',
    component: NotFoundPage,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return {top: 0}
  },
})

router.beforeEach((to, from, next) => {
  next();
  window.scrollTo(0, 0)
});

export default router
